import styled from 'styled-components';
import useSplitedTable from '../../../hooks/useSplitedTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const _tables = [
  {
    name: 'Risk measure value',
    key: 'risk_measure_value',
    order: 139
  },
  {
    name: 'Risk measure description',
    key: 'risk_measure_description',
    order: 147
  }
];

const columnLables = {
  NET_EQTY_DELTA: {
    name: 'Net equity delta',
    order: ''
  },
  NET_CTY_DELTA: {
    name: 'Net commodity delta',
    order: ''
  },
  NET_FX_DELTA: {
    name: 'Net FX delta',
    order: ''
  }
};

export function MeasureRisk({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useSplitedTable({
    data: funds[currentDataKey]?.fund_data?.MARKET_RISK_MEASURE,
    onChangeFund,
    schema: schema.MARKET_RISK_MEASURE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.MARKET_RISK_MEASURE?.field_names || [],
    isMultiFunds,
    funds,
    tables: _tables,
    columnLables,
    tableName: 'MARKET_RISK_MEASURE',
    filderedFieldName: 'risk_measure_type'
  });

  return (
    <StyledTables id="reporttables-market-risk-measure-group">
      {tables.map((rows, index) => (
        <Table
          key={index + 'MARKET_RISK_MEASURE'}
          id={`reporttables-market-risk-measure-table-${index + 1}`}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
        />
      ))}
    </StyledTables>
  );
}

const StyledTables = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: fit-content;
  &::-webkit-scrollbar {
    //    display: none;
  }
`;
